import React, { useState } from 'react';
import LoginView from '../../presentation/login-view/LoginView';

const Authentication = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
  }

  const handlePasswordInput = (e) => {
    setPassword(e.target.value);
  }

  const handleLogin = () => {
    props.onLogin(email, password).then(
      (success) => {
        if(!success) {
          setPassword('');
        }
      }
    )
  }

  const handleRegister = () => {
    props.onRegister(email, password).then(
      (result) => {
        if(!result) {
          setEmail('');
          setPassword('');
        }
      }
    )
  }

  const handleOnKeyPress = (e) => {
    if(e.charCode===13) {
      if(props.mode) { handleLogin(); }
      else { handleRegister(); }
    }
  }

  return (
    <LoginView email={email}
      handleEmailInput={handleEmailInput}
      password={password}
      handlePasswordInput={handlePasswordInput}
      handleOnKeyPress={handleOnKeyPress}
      handleLogin={handleLogin}
    />
  )
}

export default Authentication;